/*
  Style Preview.

  When a customer picks a headwear style, the main product image swaps to one
  standard reference photograph of that style, and a note explains that the item
  is still made from the fabric in the listing.

  It swaps the src on the image that is currently showing rather than covering
  the gallery with an overlay. The thumbnail rail sits in its own column and
  stays exactly where it is, so clicking any thumbnail brings the fabric back -
  which is also how someone naturally leaves the preview.
*/
(function () {
  'use strict';

  const SEL_ROOT = '.a-pdp__media';

  function init(root) {
    if (root.dataset.athenaStylePreviewReady) return;

    const dataEl = document.querySelector('[data-athena-style-refs]');
    const note = document.querySelector('[data-athena-style-note]');
    if (!dataEl || !note) return;

    let refs;
    try {
      refs = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    root.dataset.athenaStylePreviewReady = '1';

    // What we changed, so it can be put back exactly as it was.
    let held = null;

    function activeImage() {
      const active = root.querySelector('.product__media-item.is-active img');
      return active || root.querySelector('.product__media-item img');
    }

    function restore() {
      if (!held) return;
      const { img, src, srcset, sizes, alt } = held;
      if (img.isConnected) {
        img.setAttribute('src', src);
        if (srcset === null) img.removeAttribute('srcset');
        else img.setAttribute('srcset', srcset);
        if (sizes === null) img.removeAttribute('sizes');
        else img.setAttribute('sizes', sizes);
        img.setAttribute('alt', alt === null ? '' : alt);
      }
      held = null;
      note.hidden = true;
      root.classList.remove('a-pdp__media--preview');
    }

    function show(value) {
      const url = refs[value];
      if (!url) {
        restore();
        return;
      }

      const img = activeImage();
      if (!img) return;

      // Already previewing on this image: just change the picture.
      if (!held || held.img !== img) {
        restore();
        held = {
          img,
          src: img.getAttribute('src'),
          srcset: img.getAttribute('srcset'),
          sizes: img.getAttribute('sizes'),
          alt: img.getAttribute('alt')
        };
      }

      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', url);
      img.setAttribute('alt', value + ' - style reference');

      note.hidden = false;
      root.classList.add('a-pdp__media--preview');
    }

    function selectedValue() {
      const hit = document.querySelector('.a-split__real:checked');
      return hit ? hit.value : '';
    }

    // The hidden radios are the single source of truth; the split picker
    // dispatches a bubbling change on them however the choice was made.
    document.addEventListener('change', function (e) {
      const t = e.target;
      if (t && t.classList && t.classList.contains('a-split__real')) {
        show(t.value || selectedValue());
      }
    });

    // Any thumbnail, or the note's own button, returns to the fabric.
    root.addEventListener('click', function (e) {
      if (e.target.closest('.thumbnail-list__item')) restore();
    });
    note.addEventListener('click', function (e) {
      if (e.target.closest('[data-athena-style-back]')) restore();
    });

    // Deliberately not called on load: the listing must open on the fabric.
  }

  function scan() {
    document.querySelectorAll(SEL_ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
